import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Slider from "react-slick";

import grid1 from './../../images/banner/img1.jpg';
import grid2 from './../../images/banner/img2.jpg';
import grid3 from './../../images/banner/img3.jpg';

const latestBlog = [
	{ 
		image: grid1,
		date: "January 15, 2024",
		author: "Star Giga Team",
		title: "Goldcrest Dreams Tower A & B Construction Milestone Achieved",
		description: "We're excited to announce significant progress on Goldcrest Dreams Tower A and Tower B in Emirates City, Ajman. The construction has reached a major milestone with structural completion."
	},
	{ 
		image: grid2,
		date: "December 20, 2023",
		author: "Star Giga Team",
		title: "Goldcrest Views Wins Best Developer Award at Cityscape Middle East",
		description: "Star Giga is proud to announce that Goldcrest Views Tower at JLT, Dubai has won the Best Developer award for design and quality in residential building category."
	},
	{ 
		image: grid3,
		date: "November 10, 2023",
		author: "Star Giga Team",
		title: "New Launch: Goldcrest Executive in Jumeira Lake Towers",
		description: "Discover our latest premium development, Goldcrest Executive, strategically located in Jumeira Lake Towers, Dubai. Experience luxury living with world-class amenities."
	},
	{ 
		image: grid2,
		date: "October 5, 2023",
		author: "Star Giga Team",
		title: "Star Giga Community Event: Open House at Goldcrest Dreams",
		description: "Join us for an exclusive open house event at Goldcrest Dreams, Ajman. Tour our show units and learn about our innovative approach to community development."
	},
]
/* function SampleNextArrow(props) {
  const { onClick } = props;
  return (
  	<div className="owl-nav">
		<div className="owl-next la la-angle-right"  onClick={onClick}/>
	</div>	
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
	<div className="owl-nav">
		<div className=" owl-prev la la-angle-left" onClick={onClick}/>
	</div>
  );
} */

class EventSlider extends Component{	
	render(){
		var settings = {		
			arrows: true,
            slidesToShow: 3,	
			speed: 3000,
			navSpeed: 3000,	
            infinite: true,
			autoplay: true,
			responsive: [
				{
				  breakpoint: 1200,
				  settings: {
					slidesToShow: 3,
				  }
				},
				{
				  breakpoint: 991,
				  settings: {
					slidesToShow: 2,
				  }
				},
				{
				  breakpoint: 576,
				  settings: {
					slidesToShow: 1,
				  }
				}
			]
        };
		return(
				
				<Slider className="blog-carousel owl-carousel owl-btn-center-lr owl-btn-out " {...settings}>
					{latestBlog.map((item, index) => (
						<div className="item p-3"  key={index}>
							<div className="dlab-card blog-grid">
							<div className="dlab-media"><img src={item.image} alt=""/></div>
								<div className="dlab-info">
									<div className="dlab-meta">
										<ul>
											<li className="post-date"><i className="las la-calendar-alt"></i><span>{item.date}</span></li>
											<li className="post-user"><i className="las la-user"></i>By <Link to={"#"}>{item.author}</Link></li>
										</ul>
									</div>
									<h3 className="dlab-title">
										<Link to={"/blog-details"}>{item.title}</Link>
									</h3>
									<p>{item.description}</p>
									<div className="dlab-readmore">
										<Link to={"/blog-details"} className="readmore"><i className="las la-plus"></i> Read More</Link>
									</div>
								</div>
							</div>
						</div>
					))}	
				</Slider>
						
		)
		
	}
	
}

export default EventSlider;